import React from "react";
import '../CSS/Products.css';
import AllProducts from './subComponents/AllProducts.js';
import {RxDoubleArrowDown} from 'react-icons/rx';

function Products() {
  const products = AllProducts();
  
  return (
    <>
      <div className="productsPage">
        <div className="producCardsContainer">
          {
            products.map((pro)=>
              <div className="productCard" style={{"--order":pro.subProductSize}}>
                <div className="productTitle">
                  <div className="productImg">
                    <img className="productImgInner" alt="productImg" src={pro.productImage}/>
                  </div>
                  <div>
                    {pro.productName}
                  </div>
                  <div className="productTitleInfo">
                    {pro.productInfo}
                  </div>
                  <div className="productToolKitContainer">
                    <div className="productToolKit">
                      Products <span className="doubleArrow"><RxDoubleArrowDown/></span>
                    </div>
                    </div>
                </div>
                <div className="productInfo" style={{"--order":pro.subProductSize}}>
                  {
                    pro.subProducts.map((subPro)=>
                      <div className="subProductCard">
                        <div className="subProductImgOuterDiv">
                          <img className="subProductImg" alt="subproImg" src={subPro.subProductImage}/>
                        </div>
                        <div className="subProductName">
                          {
                            subPro.subProductName
                          }
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }
        </div>
      </div>

    </>
  );
}

export default Products;
